import getHeaderHeight from './getHeaderHeight'

/**
 * @typedef {Object} PageSizeOptimizerConfig
 * @property {number} minPageSize Minimal number of items
 * @property {number} itemHeight Average height (in px) of grid items
 * @property {number} numColumnsNarrow Number of columns below break point
 * @property {number} numColumnsWide Number of columns above break point
 * @property {number} columnsBreakPoint Break point where we switch to a wider grid
 */

class PageSizeOptimizer {

    /** @type {PageSizeOptimizerConfig} */
    config

    /** @type {number} */
    _viewHeight

    /** @type {number} */
    _pageSize

    /** @param {PageSizeOptimizerConfig} config */
    constructor(config) {
        this.config = config
        this.findOptimalPageSize = this.findOptimalPageSize.bind(this)
    }

    /**
     * Calculate the optimal amount of route tiles (= page size) to fill the screen without overflow.
     * @returns {number} Optimal page size
     */
    findOptimalPageSize() {
        this._calculatePageSize()
        return Math.max(this._pageSize, this.config.minPageSize)
    }

    _calculatePageSize() {
        // We are interested in the window height except the header
        const currentViewHeight = window.innerHeight - getHeaderHeight()

        // Same page size for same view height
        if (currentViewHeight === this._viewHeight) return this._pageSize

        this._viewHeight = currentViewHeight

        // Calculate visible space inside routes grid
        const routesGrid = /** @type {HTMLElement} */ (document.getElementById('search-results-grid'))
        const visibleRoutesGridHeight = this._viewHeight - routesGrid.offsetTop

        // Calculate page size based on the optimal number of rows
        const optimalRowCount = Math.round(visibleRoutesGridHeight / this.config.itemHeight)
        const isNarrow = window.innerWidth < this.config.columnsBreakPoint
        const numColumns = isNarrow ? this.config.numColumnsNarrow : this.config.numColumnsWide
        this._pageSize = optimalRowCount * numColumns
    }

}

export default PageSizeOptimizer
